import { isApiError } from "../../api/client";

/** Codes whose own message already says what to do; the generic "check your email and password" hint would contradict it. */
const SELF_EXPLAINING = new Set([
  "AUTH_LOGIN_LOCKED",
  "AUTH_RATE_LIMITED",
  "AUTH_ACCOUNT_DISABLED",
  "AUTH_SSO_REQUIRED",
  "AUTH_EMAIL_UNVERIFIED",
  "AUTH_2FA_LOCKED",
]);

/**
 * OWN-68: the "check your email and password" hint is only right for a credentials failure.
 * Locked / throttled / disabled / network errors show their real reason alone. Anti-enumeration is
 * kept server-side: unknown address and wrong password both answer `AUTH_INVALID_CREDENTIALS`.
 */
export function loginErrorNeedsCredentialsHint(error: unknown): boolean {
  if (!isApiError(error)) return true;
  if (error.status === 0 || error.status >= 500) return false;
  return !SELF_EXPLAINING.has(error.code);
}
